/**
 * Logger utility - wraps console methods to allow environment-based control
 * In production, non-critical logs are disabled to improve performance
 */

const isDev = process.env.NODE_ENV === 'development';
const isProd = process.env.NODE_ENV === 'production';

// No-op function for disabled logging
const noop = () => {};

export const logger = {
  // Debug logs - development only
  log: isDev ? (...args) => console.log('[LOG]', ...args) : noop,
  debug: isDev ? (...args) => console.debug('[DEBUG]', ...args) : noop,
  info: isDev ? (...args) => console.info('[INFO]', ...args) : noop,
  
  // Warnings - development only (enable in prod for critical apps)
  warn: isDev ? (...args) => console.warn('[WARN]', ...args) : noop,
  
  // Errors - always log (critical for debugging production issues)
  // In a real app, could send to Sentry, LogRocket, etc.
  error: (...args) => {
    if (isProd) {
      // In production, could integrate with error tracking service
      // Example: Sentry.captureException(args[0]);
    }
    console.error('[ERROR]', ...args);
  }
};

export default logger;
